import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import useSWR from "swr";
import { Image, Text, Grid, Flex, Button, Padding, Listbox } from "..";
import { useRouter } from "next/router";
import NextLink from "next/link";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
dayjs.extend(localizedFormat);

var fetcher = url => fetch(url).then(res => res.json());

var apiEndpoint = process.env.NEXT_PUBLIC_API_URL || "https://ccq-api.vercel.app";
export var NewsList = _ref => {
  var _router$query$page, _tag$name;

  var {
    per_page = 9
  } = _ref;
  var [tag, setTag] = useState();
  var router = useRouter();
  var page = parseInt(((_router$query$page = router.query.page) == null ? void 0 : _router$query$page.toString()) || "1");
  var variant = process.env.NEXT_PUBLIC_VARIANT;

  if (!variant) {
    var slug = router.asPath.split("?")[0].split("/").filter(v => v);
    if (slug.length) variant = slug[0];else variant = "dev";
  }

  var news = useSWR(apiEndpoint + "/api/v1/news/" + variant + "?page=" + page + "&per_page=" + per_page + "&with_tag=" + ((_tag$name = tag == null ? void 0 : tag.name) != null ? _tag$name : ""), fetcher);
  var tags = useSWR(apiEndpoint + "/api/v1/news/" + variant + "/tags", fetcher);
  if (news.error || tags.error) return /*#__PURE__*/_jsx("div", {
    children: "Error"
  });
  var {
    stories,
    total
  } = news.data || {};
  var pages = generatePages({
    total,
    per_page
  }) || [];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Flex, {
      justify: "end",
      children: /*#__PURE__*/_jsx(Padding, {
        y: "4",
        children: /*#__PURE__*/_jsx(Listbox, {
          onChange: setTag,
          values: tags.data || [],
          placeholder: "Filter by..."
        })
      })
    }), /*#__PURE__*/_jsx(Grid, {
      layout: "1-1-1",
      gap: "4",
      children: stories ? stories.map((story, i) => /*#__PURE__*/_jsx(NextLink, {
        href: cleanHref(story.full_slug),
        children: /*#__PURE__*/_jsxs("a", {
          "data-chromatic": "ignore",
          className: "group hover:bg-neutral/10 transition duration-150 ease-in-out flex flex-col justify-between",
          children: [story.content.meta.og_image ? /*#__PURE__*/_jsx(Image, {
            aspect: "wide",
            image: {
              id: 0,
              filename: story.content.meta.og_image
            }
          }) : null, /*#__PURE__*/_jsxs(Text, {
            padding: "4",
            className: "prose-headings:mt-0",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "mt-0 font-black",
              children: story.name
            }), /*#__PURE__*/_jsxs("p", {
              className: "grid",
              children: [/*#__PURE__*/_jsx("small", {
                className: "text-grey text-sm font-light",
                children: dayjs(story.first_published_at).format("LL")
              }), /*#__PURE__*/_jsx("small", {
                className: "text-md line-clamp-2",
                children: story.content.meta.description
              })]
            }), /*#__PURE__*/_jsx("p", {
              className: "underline text-grey-200",
              children: /*#__PURE__*/_jsx("small", {
                children: "Read more"
              })
            })]
          })]
        })
      }, i)) : /*#__PURE__*/_jsx("div", {
        className: "flex items-center justify-center h-screen col-span-3",
        children: /*#__PURE__*/_jsx("div", {
          style: {
            borderTopColor: "transparent"
          },
          className: "w-16 h-16 border-8 border-primary-400 border-solid rounded-full animate-spin"
        })
      })
    }), /*#__PURE__*/_jsx(Padding, {
      y: "8",
      children: /*#__PURE__*/_jsx(Flex, {
        gap: "4",
        children: pages.map(n => {
          if (!(n === page - 2 || n === page - 1 || n === page || n === page + 1 || n === page + 2)) return;
          return /*#__PURE__*/_jsx(Button, {
            color: "primary",
            size: "md",
            className: "font-black",
            disabled: n === page,
            onClick: () => {
              router.push({
                pathname: router.pathname,
                query: _extends({}, router.query, {
                  page: n
                })
              });
            },
            children: n
          }, n);
        })
      })
    })]
  });
};

function generatePages(_ref2) {
  var {
    total,
    per_page
  } = _ref2;
  if (!total) return [];
  var length = Math.ceil(total / per_page);
  return [...Array(length + 1).keys()].slice(1);
}
/**
 * Cleans a given href object from storyblok
 * @param href
 * @returns cleaned string
 */


export var cleanHref = function cleanHref(href, variant) {
  if (variant === void 0) {
    variant = process.env.NEXT_PUBLIC_VARIANT;
  }

  if (!href) return "";
  var url = href;

  if (url.startsWith("/")) {
    url = url.slice(1);
  }

  if (variant) {
    if (url.startsWith(variant)) {
      url = url.replace(variant, "");
      return url;
    }
  }

  return "/" + url;
};
//# sourceMappingURL=news_list.js.map